import React from "react";

const SectionTwo = () => {
	return (
		<div className="global-container py-20 text-center">
			<h4 className="text-5xl mobiles:hidden sabi-header">
				All You Need <span className="header-bg-design sabi-header">in a few clicks</span>
			</h4>
			<h4 className="text-4xl hidden mobiles:block sabi-header">
				All You Need <br />{" "}
				<span className="header-bg-design sabi-header">in a few clicks</span>
			</h4>
			<p className="mt-4 text-xl">Get a website and a registry in simple steps</p>
			<div className="mt-32 grid grid-cols-2 mobiles:grid-cols-1 gap-6 h-70vh">
				<div className="h-full bg-sbg-h-b rounded-lg mobiles:py-12 mobiles:rounded-2xl flex items-center justify-center">
					<div className="w-4/5 mx-auto text-center ">
						<img
							src={require("../../assets/event-web.svg").default}
							className="block w-full"
							alt=""
						/>
						<h4 className="mt-6 sabi-header text-4xl">Event Website</h4>
						<p className="mt-4">Create an event in minutes</p>
					</div>
				</div>
				<div className="h-full bg-sbg-h-p rounded-lg mobiles:py-12 mobiles:rounded-2xl flex items-center justify-center">
					<div className="w-4/5 mx-auto text-center ">
						<img
							src={require("../../assets/gift-registry.svg").default}
							className="block w-full"
							alt=""
						/>
						<h4 className="mt-6 sabi-header text-4xl">Gift registry</h4>
						<p className="mt-4">View all our gifts</p>
					</div>
				</div>
			</div>

			<div className="flex justify-center"></div>
		</div>
	);
};

export default SectionTwo;
